import { render, staticRenderFns } from "./kioskLeftNav.vue?vue&type=template&id=27233aad&scoped=true&"
import script from "./kioskLeftNav.vue?vue&type=script&lang=js&"
export * from "./kioskLeftNav.vue?vue&type=script&lang=js&"
import style0 from "./kioskLeftNav.vue?vue&type=style&index=0&id=27233aad&lang=scss&scoped=true&"
import style1 from "./kioskLeftNav.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27233aad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VFlex,VIcon,VImg,VLayout})
